import React, {useState, useEffect} from 'react';
import {Button} from 'react-native-paper';
import PropTypes from 'prop-types';

const PrimaryButton = (props) => {
  const {icon, onPress, children} = props;
  const [disabled, setDisabled] = useState(props.disabled);

  useEffect(() => {
    setDisabled(props.disabled);
  }, [props.disabled]);

  const _onPress = () => {
    setDisabled(true);
    onPress();
  };

  return (
    <Button
      icon={icon}
      disabled={disabled}
      mode="outline"
      onPress={_onPress}
      buttonColor="#828282">
      {children}
    </Button>
  );
};
PrimaryButton.propTypes = {
  icon: PropTypes.any,
  onPress: PropTypes.func,
  children: PropTypes.any,
  disabled: PropTypes.bool,
};

export default PrimaryButton;
